/**
 * Shared formatters — single source of truth so cards.tsx and CardTrend.tsx (and
 * anyone else) format money identically and there's no circular import between
 * them (Codex 2026-06-13).
 */

export const moneyFmt = (n: number | null | undefined): string =>
  n === null || n === undefined
    ? "—"
    : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n);
